require('./rents.scss');
const PropTypes = require('prop-types');
const React = require('react');
const { Component } = require('react');

// @components
const { LoadingSection } = require('commonsComponents/loadingSection');
const DropdownAccounts = require('components/dropdownAccounts/dropdownAccounts');
const { AccordionRow } = require('commonsComponents/accordionRow');
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const OKTableRowDetails = require('components/rebrand/OKTableRowDetails/OKTableRowDetails');
const OKTableRowDetailsItem = require('components/rebrand/OKTableRowDetails/OKTableRowDetailsItem/OKTableRowDetailsItem');
const { EmptyState } = require('commonsComponents/emptyState');
const { OKLink } = require('commonsComponents/OKLink');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @helpers;
const { getFormattedString, formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;

class Rents extends Component {
    constructor(props) {
        super(props);

        this.handleToggleClick = this.handleToggleClick.bind(this);
        this.handleAccountChange = this.handleAccountChange.bind(this);
        this.handleRetry = this.handleRetry.bind(this);

        this.state = {
            selected: [],
            accountId: props.taxAndRents.get('accountId')
        };
    }

    buildDetailsRow(immRentReturn) {
        const { taxAndRents, immAccounts } = this.props;
        const accountId = taxAndRents.get('accountId');
        const immAccount = immAccounts.getIn(['byId', accountId]);
        const operationDate = immRentReturn.get("operationDate");
        const valueDate = immRentReturn.get("valueDate");
        const holder = immAccount.get("accountHolder");
        const nif = immRentReturn.get("document");
        const diferentialPay = getFormattedString(immRentReturn.get("diferentialPay").toJS());
        const type = immRentReturn.get("type") === "0" ? formatText('taxAndRents-toAdd') : formatText('taxAndRents-toReturn');
        const adminCode = immRentReturn.get("admin");
        const documentCode = immRentReturn.get("documentCode");
        const nrc = immRentReturn.get("nrc");
        return [
            {
                label: 'taxAndRents-operationDate',
                value: operationDate || '-',
            },
            {
                label: 'taxAndRents-type',
                value: type || '-',
            },
            {
                label: 'taxAndRents-valueDate',
                value: valueDate || '-',
            },
            {
                label: 'taxAndRents-adminCode',
                value: adminCode || '-',
            },
            {
                label: 'taxAndRents-holder',
                value: holder || '-',
            },
            {
                label: 'taxAndRents-documentCode',
                value: documentCode || '-',
            },
            {
                label: 'taxAndRents-nif',
                value: nif || '-',
            },
            {
                label: 'taxAndRents-nrc',
                value: nrc || '-',
            },
            {
                label: 'taxAndRents-diferentialPay',
                value: diferentialPay || '-',
            },
        ];
    }

    buildDetails(immRentReturn) {
        const items = this.buildDetailsRow(immRentReturn);
        const itemContainer = items.map(({ label, value }, index) => (
            <OKTableRowDetailsItem
                key={`firstColumnTransferInfo-${index}`}
                title={label}
                value={value}
            />
        ));
        return (
            <div className="rents__details">
                <OKTableRowDetails columns={2} title={'taxAndRents-detailsTitle'}>
                    {itemContainer}
                </OKTableRowDetails>
            </div>
        )
    }

    handleToggleClick(index) {
        const { taxAndRents } = this.props;
        const taxReturn = taxAndRents.getIn(['byId', index]);
        const selectedArray = this.state.selected;
        if (this.state.selected.indexOf(index) !== -1) {
            const i = selectedArray.indexOf(index);
            selectedArray.splice(i, 1);
        } else {
            if (!taxReturn.get('operationDate')) {
                this.props.postGetDetails(index);
            }
            selectedArray.push(index);
        }
        this.setState({ selected: selectedArray });
    }

    getPeriod(period) {
        switch (period) {
            case '0A':
                return formatText('taxAndRentsTable-periodAnual');
            case '1T':
                return formatText('taxAndRentsTable-period1Trim');
            case '2T':
                return formatText('taxAndRentsTable-period2Trim');
            case '3T':
                return formatText('taxAndRentsTable-period3Trim');
            case '4T':
                return formatText('taxAndRentsTable-period4Trim');
            case '1S':
                return formatText('taxAndRentsTable-period1Semester');
            case '2S':
                return formatText('taxAndRentsTable-period2Semester');
        }
    }

    handleRetry() {
        const { accountId } = this.state;
        this.props.handleAccountChange(accountId);
    }

    buildErrorState() {
        const primaryText = formatText('taxAndRents-errorMessage');
        const retryButton = (
            <OKButton
                id="btn_accountRents_retry"
                onClick={this.handleRetry}>
                <FormattedText value="taxAndRents-retry" />
            </OKButton>
        );

        return (
            <EmptyState
                button={retryButton}
                primaryText={primaryText}
                iconType="nointernet-banking" />
        );
    }

    buildTable() {
        const { taxAndRents, maxNumberOfRows, showButton } = this.props;
        const taxAndRentsByOrder = taxAndRents.get('byOrder');
        const size = taxAndRentsByOrder.size

        if (taxAndRents.get('isFetching')) {
            return <LoadingSection />;
        } else if (taxAndRents.get('error')) {
            return this.buildErrorState();
        } else if (size === 0) {
            return (
                <EmptyState
                    primaryText={formatText('taxAndRents-noRents')}
                    iconType="transfer-banking"
                />);
        } else {
            const taxAndRentsById = taxAndRents.get('byId');
            const taxsAndRentsCount = Math.min(size, maxNumberOfRows);

            let buttonShowAll;
            if (showButton && taxsAndRentsCount < size) {
                buttonShowAll = (
                    <div className="rents__show-all">
                        <OKLink modifier="emphasize" to={'/myprofile/taxAndRents/rents'} >
                            <FormattedText value="taxAndRents-seeAll" format="firstUppercase" />
                        </OKLink>
                    </div>
                );
            }
            const rows = taxAndRentsByOrder.take(maxNumberOfRows).map((taxReturnId, index) => {
                const taxReturn = taxAndRentsById.get(taxReturnId);
                const model = taxReturn.get('model') === 100 ? '100 I.R.P.F' : taxReturn.get('model');
                const period = this.getPeriod(taxReturn.get('period'));
                const type = taxReturn.get('type') === "0" ? formatText('taxAndRents-toAdd') : formatText('taxAndRents-toReturn');
                const plainAmountObject = getPlainAmountObject(taxReturn.get('amount'));

                const rowCells = [
                    {
                        element: model,
                        className: 'rents__model-cell'
                    },
                    {
                        element: taxReturn.get('reference'),
                        className: 'rents__reference-cell'
                    },
                    {
                        element: taxReturn.get('excercise') + 2000,
                        className: 'rents__excercise-cell'
                    },
                    {
                        element: period,
                        className: 'rents__period-cell'
                    },
                    {
                        element: type,
                        className: 'rents__maximum-cell'
                    },
                    {
                        element: <OneLineSymbolAmount
                            amountObject={plainAmountObject}
                            language={getLanguage()}
                            amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />,
                        className: 'rents__maximum-cell'
                    }
                ];
                let contentRow;
                if (taxReturn.get('operationDate')) {
                    contentRow = this.buildDetails(taxReturn);
                } else {
                    contentRow = <LoadingSection />
                }
                return (
                    <AccordionRow
                        key={index}
                        index={taxReturn.get('reference')}
                        rowCells={rowCells}
                        onToggleClick={this.handleToggleClick}
                        visible={this.state.selected.indexOf(taxReturn.get('reference')) !== -1}
                    >
                        <OKTableCell colSpan={7}>
                            {contentRow}
                        </OKTableCell>
                    </AccordionRow>
                );
            });

            return (
                <div>
                    <OKTable>
                        <thead>
                            <OKTableRow asHeader={true}>
                                <OKTableCell
                                    asHeader={true}
                                    className="rents__toggle"
                                />
                                <OKTableCell
                                    asHeader={true}
                                    className="rents__model"
                                >
                                    <FormattedText value="taxAndRentsTable-model" />
                                </OKTableCell>
                                <OKTableCell
                                    asHeader={true}
                                    className="rents__reference"
                                >
                                    <FormattedText value="taxAndRentsTable-document" />
                                </OKTableCell>
                                <OKTableCell
                                    asHeader={true}
                                    className="rents__excercise"
                                >
                                    <FormattedText value="taxAndRentsTable-excercise" />
                                </OKTableCell>
                                <OKTableCell
                                    asHeader={true}
                                    className="rents__period"
                                >
                                    <FormattedText value="taxAndRentsTable-period" />
                                </OKTableCell>
                                <OKTableCell
                                    asHeader={true}
                                    className="rents__maximum"
                                >
                                    <FormattedText value="taxAndRentsTable-type" />
                                </OKTableCell>
                                <OKTableCell
                                    asHeader={true}
                                    className="rents__period"
                                >
                                    <FormattedText value="taxAndRentsTable-amount" />
                                </OKTableCell>
                            </OKTableRow>
                        </thead>
                        {rows}
                    </OKTable>
                    {buttonShowAll}
                </div>
            );
        }

    }

    handleAccountChange(accountId) {
        if (accountId !== this.state.accountId) {
            this.setState({
                accountId,
                selected: []
            });
            this.props.handleAccountChange(accountId);
        }
    }

    render() {
        const { immAccounts, isInactiveAccountsEnabled, taxAndRents } = this.props;
        const titleText = formatText('taxAndRents-subtitle');
        const accountsIndexes = immAccounts.get('byOrder').toJS();
        const accounts = immAccounts.get('byId');
        if (!taxAndRents.get('accountNumber')) {
            this.handleAccountChange(accountsIndexes[0]);
        }
        const table = taxAndRents.get('accountNumber') ? this.buildTable() : '';
        const dropdownLabel = formatText('taxAndRents-rentsAccount');
        const tooltipMsgContent = isInactiveAccountsEnabled ? 'inactiveAccounts-inactiveAccounts_consultiveDropdownCommonToolTip' : '';

        return (
            <div className="rents">
                <OKBoxTitle value={titleText} />
                <div className="rents__dropdown">
                    <DropdownAccounts
                        id="broker-stocks-contracts"
                        label={dropdownLabel}
                        immAccounts={accounts}
                        accountsIndexes={accountsIndexes}
                        currentAccountId={this.state.accountId}
                        onAccountChange={this.handleAccountChange}
                        tooltipMsg={tooltipMsgContent}
                    />
                </div>
                {table}
            </div>
        )
    }
}

Rents.propTypes = {
    immAccounts: PropTypes.object.isRequired,
    isInactiveAccountsEnabled: PropTypes.bool.isRequired,
    handleAccountChange: PropTypes.func.isRequired,
    taxAndRents: PropTypes.object.isRequired,
    postGetDetails: PropTypes.func.isRequired,
    maxNumberOfRows: PropTypes.number,
    showButton: PropTypes.bool
}

Rents.defaultProps = {
    maxNumberOfRows: 20
}

module.exports = Rents;
